export default "__VITE_ASSET__offn9C1p__"